<template>
  <div class="login-wrap" style="width: 1200px; margin: 20px auto">
    <div class="header_logo">
      <el-image class="logo" :src="logo" fit="fill">
        <div slot="error" class="image-slot">
          <i class="el-icon-picture-outline"></i>
        </div>
      </el-image>
    </div>
    <div class="textBox">
      <div class="row">
        <div class="col-sm-12">
          <form
            method="post"
            role="form"
            id="register"
            class="login-form fade-in-effect in"
            novalidate="novalidate"
          >
            <h4 class="registerBookTitle">{{title}}</h4>
            <div v-if="content" v-html="content"></div>
            <div style="text-align: center;" v-if="content==''">暂无相关内容</div>
           </form>
          <!-- Add class "fade-in-effect" for login form effect -->
        </div>
      </div>
    </div>
    <div class="footer_info">
        <p class="text-center" style="line-height: 30px;">{{informations.copyrightInformation}}<br>
          <a :href="informations.icpUrl" target="_blank">{{informations.icp}}</a>
        </p>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { registerBook,setImage,copyRight } from "@/api/xunyou";
import { setCookie, getCookie, delCookie } from "../utils/util";
import md5 from "js-md5";
export default {
  data() {
    return {
      content:'',
      title:'',
      logo:'',
      informations:{}
    };
  },
  // 创建完毕状态(里面是操作)
  created() {
    this.getRegisterBook()
    this.geTCopyright()
    this.getImagelogo()
  },
  // 里面的函数只有调用才会执行
  methods: {
    // 获取版权名称
    geTCopyright(){
      copyRight().then(res=>{
        if(res.code==0){
          this.informations = res.rows[0]
          if(this.informations.powstatus==1){
            this.$router.push('/erroPage')
          }else{
             this.$store.commit('getcopyRight',this.informations)
          }
        }
      }).catch(err=>{
        this.$message.error('查询失败,请稍后再试!')
      })
    },
    // 获取logo
    getImagelogo(){
      setImage().then(res=>{
          if(res.code==0){
            this.logo = res.rows[0].pcLogo
          }
        })
    },
    getRegisterBook() {
          registerBook()
            .then((res) => {
              if (res.code == 0) {
                if(res.rows.length>0){
                  this.content=res.rows[0].content
                  this.title=res.rows[0].title
                }
              } else {
                this.$message.error(res.msg);
              }
            })
            .catch((err) => {
              this.loading = false;
              this.$message.error("查询失败，请稍后再试！");
            });
    },
  },
};
</script>

<style scoped lang='less'>
/deep/ .logo img{
  width: 255px;
  height: 52px;
}
.login-wrap {
  box-sizing: border-box;
  width: 100%;
  height: 100%;

  .header_logo {
    padding: 30px 0px;
    margin: auto;
  }
  .textBox{
    border-bottom: 1px solid #b5b5b5;
    padding-bottom: 40px;
    box-sizing: border-box;
    .registerBookTitle{
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
    }
}
  .footer_info {
    text-align: center;
    font-size: 14px;
    padding: 20px;
    p.text-center {
      color: #979898;
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/userAgreement.vue